import React from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";

import "./DetailsHeader.scss";
const DetailsBox = ({ icon, values, title, borderLeft, background }) => {
  return (
    <div className="details-box" style={{ borderLeft, background }}>
      {icon && (
        <div className="iconContainer">
          <img src={icon} alt={title} />
        </div>
      )}
      <div className="title-value">
        <div className="valueHeader" style={{ fontFamily: "Red Hat Display" }}>
          {values}
        </div>
        <div className="titleHeader">{title}</div>
      </div>
    </div>
  );
};
// DetailsBox.propTypes = {
//   icon: PropTypes.string.isRequired,
//   values: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//   title: PropTypes.string.isRequired,
//   borderLeft: PropTypes.string,
// };

const DetailsHeader = ({ data, background }) => {
  return (
    <div
      className="driver-header"
      style={{ background: background ? background : "#fff" }}
    >
      {data.map((item, index) => (
        <DetailsBox
          key={index}
          icon={item.icon}
          values={item.values}
          title={item.title}
          borderLeft={index > 0 ? "1px solid var(--Gray-06, #E3E5E8)" : "none"}
          background={background}
        />
      ))}
    </div>
  );
};

DetailsHeader.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      values: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DetailsHeader;
